import { IconChevronRight, IconChevronUp, IconChevronDown } from '@/components/atoms/Icon';
import { ReactNode } from 'react';
import { ButtonWrapper } from './ButtonWithIcon.styled';
import { Subtitle } from '@/components/atoms';

interface IProps {
  children: ReactNode;
  color?: string;
  onClick: () => void;
  iconName: string;
  textLevel: number;
}

const ButtonWithIcon = (props: IProps) => {
  const { children, onClick, color, iconName, textLevel } = props;

  const IconComponent: { [key: string]: ReactNode } = {
    chevronRight: <IconChevronRight width={20} color={color} />,
    chevronUp: <IconChevronUp width={20} color={color} />,
    chevronDown: <IconChevronDown width={20} color={color} />,
  };

  return (
    <ButtonWrapper onClick={onClick}>
      <Subtitle level={textLevel} color={color}>
        {children}
      </Subtitle>
      {IconComponent[iconName]}
    </ButtonWrapper>
  );
};

export default ButtonWithIcon;
